import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './FireRiskAssessment.module.scss';

export const FireRiskAssessment = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/fire-risk-assessment/Fire Risk Assessment.webp"
        imageAlt="Fire Extinguishers undergoing examination"
        title="Fire Risk Assessment"
      />
      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={styles.inner_section}>
                <TitleAndDescComponent
                  styles={styles}
                  title="Comprehensive Fire Risk Assessment in London"
                  description="Your safety is our priority. Our expert team offers fire security solutions to keep your home and property protected. From assessments to fire safety equipment, we provide complete fire safety for your peace of mind."
                />

                <CTAButton
                  title="Schedule Fire Risk Assessment"
                  serviceName="Fire safety"
                />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle="Fire Safety Solutions"
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/fire-risk-assessment/Fire Risk Assessment.webp"
                      imgAlt="Fire Safety Expert examining Fire Extinguishers"
                      title="Fire Risk Assessment"
                      description="A thorough fire risk assessment is the first step in maintaining a safe environment for your property. Our team of fire safety experts conducts detailed inspections, identifying fire hazards and evaluating current safety measures. We provide clear guidance and recommendations to mitigate risks, ensuring your property complies with all fire safety regulations. With our fire risk assessments, you can be confident in the safety of your premises."
                    />

                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/fire-risk-assessment/Fire Doors.webp"
                      imgAlt="Fire Door lock mechanism up close"
                      title="Fire Doors"
                      description="Fire doors are crucial for containing blazes and safeguarding escape routes in your property. We provide, fit, and service top-tier fire doors that exceed rigorous safety benchmarks, guaranteeing optimal performance and defence during emergencies. Our expert services foster compliance with regulations while bolstering your property's security, delivering peace of mind and uncompromising protection against potential fire hazards."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/fire-risk-assessment/Emergency Lighting and Smoke Alarms.webp"
                      imgAlt="Smoke Alarm detector"
                      title="Emergency Lighting and Smoke Alarms"
                      description="Emergency lighting and smoke alarms are vital components of any fire security plan. We offer expert installation and maintenance of emergency lighting systems and smoke alarms to ensure safe evacuation and early detection during an emergency. Our solutions are tailored to meet the specific requirements of your home or property and provide peace of mind."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.root}>
        <EmergencyComponent
          title="Fire Safety Expert"
          imageSrc="/images/services/fire-risk-assessment/Fire Safety Expert.webp"
          imageAlt="Fire Safety Expert examining fire alarm system"
          styles={styles}
          para1="Fire safety is crucial for every property, whether residential or commercial. Our fire protection services ensure that you are prepared and protected at all times."
          para2="Specialising in fire risk assessments, our Fire Safety Experts identify potential hazards to help you take the necessary steps to stay compliant and safe. This includes comprehensive fire solutions, such as risk assessments, fire alarms, and emergency lighting, to help secure your home and property."
        />
        <ListOfServices
          styles={styles}
          serrviceList={[
            { name: 'Fire Risk Assessment' },
            { name: 'Fire Doors' },
            { name: 'Emergency Lighting and Smoke Alarms' },
          ]}
        />
        <AreasWeCover styles={styles} />
        <PostCodes
          styles={styles}
          mainPageUrl="/services/fire-risk-assessment"
        />
        <FAQsView title="Fire and Safety FAQs" faqItems={faqItems} />
      </div>
    </>
  );
};
// {name: ""},

const faqItems = [
  {
    title: 'Is fire risk assessment necessary?',
    details: `It’s a legal requirement for businesses and multi-occupancy residential properties in the UK.`,
  },
  {
    title: 'Are emergency lighting systems necessary?',
    details:
      'It’s required in commercial buildings and multi-occupancy residences to ensure safe evacuation.',
  },
  {
    title: 'Are fire doors necessary?',
    details: `They are required in commercial buildings, multi-occupancy residences, and certain areas of single-family homes. Proper installation and maintenance are essential for their effectiveness.`,
  },
  {
    title: 'Are fire safety services available for residential properties?',
    details: `Yes, fire safety services are available for both residential and commercial properties. These services can include fire alarm installation, fire extinguisher provision, and safety assessments.`,
  },
];
